export default __webpack_public_path__ + "static/media/oversight1.3be29074.png";